import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { analyticsTrack } from '../../analyticsUtils';
import { getRequest, postRequest } from '../../requestUtils';
import ProjectInvitationCustomTextbox from './ProjectInvitationCustomTextbox';

class InviteConsultant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: props.project ? 'review' : 'create',
      projects: [],
      project: props.project,
      isInvalid: false,
      customMessage: '',
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInvite = this.handleInvite.bind(this);
    this.handleUpdateCustomMessage = this.handleUpdateCustomMessage.bind(this);
  }

  componentDidMount() {
    const { csrfToken, defaultProjectId } = this.props;
    return getRequest('/projects', { status: 'search' }, csrfToken).then((response) => {
      const project = response.data.find((proj) => proj.resource_id === defaultProjectId);
      this.setState({
        projects: response.data,
        project: project ? { label: project.name, value: defaultProjectId } : null,
      });
    });
  }

  handleSelectChange(project) {
    this.setState({ project });
  }

  handleInvite() {
    const {
      handleInvited, consultant, csrfToken, query,
    } = this.props;
    const { project, customMessage } = this.state;
    postRequest(
      `/projects/${project.value}/project_invitations`,
      {
        consultant_resource_id: consultant.resource_id,
        query_id: query,
        custom_message: customMessage,
        request_proposal: true,
      },
      csrfToken,
    ).then(() => {
      analyticsTrack(
        'Clicked on Send & Connect inside the Invite Consultant Modal',
        { location: 'Consultant Profile Page' },
      );
      handleInvited(project.value);
    }).catch(() => {
      this.setState({ isInvalid: true });
    });
  }

  handleUpdateCustomMessage(customMessage) {
    this.setState({ customMessage });
  }

  render() {
    const { consultant, goToQuestions, defaultProjectId } = this.props;
    const {
      projects, project, isInvalid, customMessage,
    } = this.state;
    const defaultProject = projects.filter((p) => p.resource_id === defaultProjectId)
      .map((p) => ({ value: p.resource_id, label: p.name }));
    return (
      <div className="invite-consultant">
        <div className="consultant-detail">
          <div className="init-icon">
            <span className="icon-initials">{ consultant.initials }</span>
          </div>
          <div className="body-text-2 medium-weight invite-heading">
            {`Tell ${consultant.first_name} about your project and who you’re looking for.`}
          </div>
        </div>
        <div className="invite-container">
          <div className="form-group mb-8">
            <label htmlFor="project">
              <div className="body-text-2 medium-weight">
                Select an existing project:
              </div>
            </label>
            <Select
              id="project"
              className="body-text-2"
              classNamePrefix="select-project"
              placeholder="Select or type..."
              options={projects.map((p) => ({ value: p.resource_id, label: p.name }))}
              value={project || defaultProject}
              onChange={(option) => {
                this.handleSelectChange(option);
                analyticsTrack(
                  'Clicked on a project inside the Invite Consultant Modal',
                  { location: 'Consultant Profile Page' },
                );
              }}
            />
          </div>
          {isInvalid
            && (
            <div className="error-message">
              <i className="fa fa-exclamation-triangle" />
              This project was already sent to
              {' '}
              {consultant.name}
            </div>
            )}
          <div className="mt-3 mb-12">or</div>
          <button
            className="btn btn-secondary-no-border create-new-project"
            onClick={() => {
              analyticsTrack(
                'Clicked on Create a new project inside the Invite Consultant Modal',
                { location: 'Consultant Profile Page' },
              );
              goToQuestions();
            }}
          >
            <i className="fa fa-plus" />
            Create a new project
          </button>
          {project
            && (
            <ProjectInvitationCustomTextbox
              consultantFirstName={consultant.first_name}
              updateParentMessage={this.handleUpdateCustomMessage}
              customMessage={customMessage}
            />
            )}
          <div className="actions">
            <button
              className="btn btn-primary standard-button review-and-send"
              onClick={() => this.handleInvite()}
              disabled={project === null}
            >
              Send & Connect!
            </button>
          </div>
        </div>
      </div>
    );
  }
}

InviteConsultant.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  project: PropTypes.shape({}),
  goToQuestions: PropTypes.func.isRequired,
  handleInvited: PropTypes.func.isRequired,
  csrfToken: PropTypes.string.isRequired,
  query: PropTypes.number,
  defaultProjectId: PropTypes.string,
};

InviteConsultant.defaultProps = {
  project: null,
  query: null,
  defaultProjectId: null,
};

export default InviteConsultant;
